<div class="all-features-disabled-block">
    <div class="illustration-wrapper">
        <app-image name="allFeatureTurnOffSvg"></app-image>
    </div>
    <div class="content-wrapper">
        <h3 class="title text-16-400 color-8 mb-0">{{ ss.t('featuresDisabled_screenDisabledContent') }}</h3>
        <p class="subtitle text-12-400 color-7 mb-0">{{ ss.t('common_featuresTurnedOffEmptyScreenContent1') }}</p>
    </div>
    <button class="btn manage-features-btn" (click)="navigateToFeatures()">
        {{ ss.t('common_manageFeatures') }}
    </button>
</div>
